<div class="relative flex flex-col w-full h-full cursor-default">

    <!-- Content -->
    <div class="flex flex-col sm:flex-row flex-auto items-center sm:items-start p-8 pb-6 sm:pb-8">

        <!-- Icon -->
        <ng-container>
            <div
                class="flex flex-0 items-center justify-center w-10 h-10 sm:mr-4 rounded-full text-red-500 bg-red-100 dark:text-red-50 dark:bg-red-500"
                >
                <mat-icon
                    class="text-current"
                    [svgIcon]="'heroicons_outline:exclamation'"></mat-icon>
            </div>
        </ng-container>

        <ng-container>
            <div class="flex flex-col items-center sm:items-start mt-4 sm:mt-0 sm:pr-8 space-y-1 text-center sm:text-left">

                <!-- Title -->
                <ng-container>
                    <div
                        class="text-xl leading-6 font-medium"
                        >
                        {{'alert.remove_job_from_route' | translate}}
                    </div>
                </ng-container>

                <!-- Message -->
                <ng-container>
                    <div>
                        <p class="text-secondary">
                            {{'alert.remove_job_from_route_message' | translate}} <span class="font-semibold">{{data?.data?.job_title}} </span>?
                        </p>
                        <div class="mt-3 flex items-center" *ngIf="data?.checkbox">
                            <input id="unassignEmployee" type="checkbox" [(ngModel)]="unassignEmployee" [checked]="unassignEmployee" class="w-4 h-4 z-text disabled:text-gray-300 bg-gray-100 border-gray-300 rounded focus:outline-none focus:ring-0 focus:ring-gray-50">
                            <label for="unassignEmployee" class="pl-3 cursor-pointer">{{'confirmation.remove_employee' | translate}}</label>
                        </div>
                    </div>
                </ng-container>
            </div>
        </ng-container>

    </div>

    <!-- Actions -->
    <ng-container >
        <div class="flex items-center justify-center sm:justify-end px-6 py-4 space-x-3 bg-gray-50 dark:bg-black dark:bg-opacity-10">

            <!-- Cancel -->
            <ng-container>
                <button
                    mat-stroked-button
                    [matDialogClose]="false" class="px-6 flex items-center py-2 border shadow-sm text-gray-600 bg-white text-base font-medium rounded-md btn-small">
                    {{'cancel.text' | translate}}
                </button>
            </ng-container>

            <!-- Confirm -->
            <ng-container>
                <button
                    (click)="removeJob()"
                    class="px-6 flex items-center py-2 border shadow-sm text-white text-base font-medium rounded-md btn-small text-white bg-red-500">
                    {{'alert.confirm.remove_job' | translate}}
                </button>
            </ng-container>

        </div>
    </ng-container>

</div>
